import * as React from 'react';
import { useMemo } from 'react';
import { POINTS_RANGES } from './constants';
import styles from './PointsFilter.module.scss';

interface PointsFilterProps {
    activeRange: string;
    onChange: (range: string) => void;
    /** All rewards data for checking which tabs have content */
    allData?: Array<{ points: number }>;
}

const PointsFilter: React.FC<PointsFilterProps> = ({ activeRange, onChange, allData = [] }) => {
    // Filter out tabs that have no data
    const availableRanges = useMemo(() => {
        if (!allData?.length) return [];

        return POINTS_RANGES.filter((range) => {
            // Check if any item falls into this range
            return allData.some((item) => range.filter(item.points));
        });
    }, [allData]);

    // Don't render if no tabs available
    if (!availableRanges.length) return null;

    return (
        <div className={styles.pointsFilter}>
            {availableRanges.map((range) => (
                <button key={range.key} className={`${styles.filterBtn} ${activeRange === range.key ? styles.active : ''}`} onClick={() => onChange(range.key)}>
                    {range.label}
                </button>
            ))}
        </div>
    );
};

export default PointsFilter;
